export const withLatency = async <T>(value: T, ms = 250): Promise<T> => {
  await new Promise((resolve) => setTimeout(resolve, ms))
  return value
}
